import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";

export const SOLANA_NETWORK =
  process.env.REACT_APP_ENV === "development" ? WalletAdapterNetwork.Devnet : WalletAdapterNetwork.Mainnet;

export const SOLANA = { name: "Solana", symbol: "SOL", decimals: 9 };
